import type { ReactElement } from 'react';

import { timelineItemView } from '../timeline-presentation';
import type { DossierTimelineItem } from '../types';
import { formatDate } from '@/lib/time';

interface Props {
  items: DossierTimelineItem[];
  /** Próxima revisión programada del documento (se muestra como nodo final pendiente). */
  nextReviewAt: string | null;
}

/** Historial mezclado de versiones y firmas (más reciente arriba). El nodo final
 *  "Próxima revisión programada" sale de la fecha de revisión del documento, no del
 *  timeline (es futuro, no un evento ocurrido). */
export function VersionTimeline({ items, nextReviewAt }: Props): ReactElement {
  const versions = new Set(items.map((i) => i.version));
  const count =
    items.length === 0
      ? 'sin eventos'
      : `${versions.size} ${versions.size === 1 ? 'versión' : 'versiones'} · trazadas`;

  const isEmpty = items.length === 0 && nextReviewAt === null;

  return (
    <div className="card rise d1">
      <div className="ch">
        <h3>Historial de versiones y firmas</h3>
        <span className="count">{count}</span>
      </div>
      <div className="cb tl" style={{ padding: '20px 24px' }}>
        {isEmpty ? (
          <p className="soft" style={{ fontSize: 13 }}>
            Sin eventos de flujo todavía.
          </p>
        ) : (
          <>
            {items.map((item, idx) => {
              const v = timelineItemView(item);
              return (
                <div
                  key={`${item.kind}-${item.version}-${item.at}-${idx}`}
                  className={`ev ${v.marker}`}
                >
                  <div className="t">{v.title}</div>
                  <div className="w">{v.detail}</div>
                </div>
              );
            })}
            {nextReviewAt !== null && (
              <div className="ev">
                <div className="t">Próxima revisión programada</div>
                <div className="w">
                  {formatDate(nextReviewAt)} · notificación automática antes del vencimiento
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
